
export default [
  {
    url: '/dashboard',
    name: 'داشبورد',
    icon: 'HomeIcon',
    i18n: 'داشبورد',
    slug: "config",
    permissionId:'home'
  },
  {
    url: '/config',
    icon: 'SlidersIcon',
    i18n: 'پیکربندی',
    slug: 'config',
    permissionId:'config'
  },
  {
    url: "/proposal",
    name: "proposal",
    slug: "proposal",
    icon: "FileTextIcon",
    i18n: "درخواست ها",
    permissionId:'request'
  },
  {
    url: "/personel",
    name: "personel",
    slug: "personel",
    icon: "UsersIcon",
    i18n: "اطلاعات پرسنلی",
    permissionId:'personnel'
  },
  {
    url: "/contract",
    name: "contract",
    slug: "contract",
    icon: "AlignJustifyIcon",
    i18n: "قرارداد ها",
    permissionId:'personnel.contract.show'
  },
  {
    url: "/permission",
    name: "permission",
    slug: "permission",
    icon: "SettingsIcon",
    i18n: "سطح دسترسی",
    permissionId:'permission.show'
  },
  {
    url: "/users",
    name: "users",
    slug: "users",
    icon: "UserIcon",
    i18n: "کاربران",
    permissionId:'user'
  },
  {
    url: "/restore",
    name: "restore",
    slug: "restore",
    icon: "ArchiveIcon",
    i18n: "بایگانی",
    permissionId:'archive'
  }
]


